<template>
    <div class="topbar-container">
        <validation-observer v-slot="{ invalid }" ref="form">
            <zbView :isEmpty="!addressList.length" class="buy-container" @reLoad="loadList(true)">
                <div class="warning-container bh bc">
                    <div class="c_warning fz_24 topText">仅能修改一次，修改后将按照修改后的地址发货</div>
                </div>
                <div class="address-list">
                    <div class="fz_34 title">当前下单地址</div>
                    <div class="address-list-item">
                        <div class="item bh bstart">
                            <div class="bg-contain ico-location"></div>
                            <div class="b1">
                                <div class="bh bstart fz_30">
                                    {{info.orderCusAddr.name}}&emsp;
                                    {{info.orderCusAddr.telephone}}
                                </div>
                                <div class="address fz_28">{{info.orderCusAddr.address}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="address-list">
                    <div class="fz_34 title">修改收货人信息</div>
                    <validation-provider rules="required" :customMessages="{required:'请选择新地址'}">
                        <van-radio-group v-model="selectId">
                            <div
                                v-for="item in addressList"
                                :key="item.id"
                                @click="onSelectClick(item)"
                                class="address-list-item border-bottom"
                            >
                                <van-swipe-cell :before-close="beforeClose">
                                    <div class="item bh bstart">
                                        <van-radio :name="item.id" class="radio"></van-radio>
                                        <div class="bg-contain ico-location"></div>
                                        <div class="b1">
                                            <div class="bh bstart fz_30">
                                                <div class="name">{{item.contact}}</div>
                                                {{item.telephone}}
                                            </div>
                                            <div class="address fz_28 bh bstart">
                                                <div class="def fz_24 r4" v-if="item.isDefault">默认</div>
                                                {{item.allAddress}}
                                            </div>
                                        </div>
                                        <div
                                            class="btn-container"
                                            @click.stop="onEditClick(item.id)"
                                        >
                                            <div class="bg-contain ico-edit"></div>
                                        </div>
                                    </div>
                                    <template slot="right">
                                        <div class="bh bc swipe-right">
                                            <van-button
                                                @click="onDelClick(item.id)"
                                                class="r6"
                                                type="danger"
                                                size="small"
                                                text="删除"
                                            />
                                        </div>
                                    </template>
                                </van-swipe-cell>
                            </div>
                        </van-radio-group>
                    </validation-provider>
                </div>

                <div class="line"></div>
            </zbView>
            <div class="buybar bh bc">
                <!-- 最多只能有20个收货地址 -->
                <van-button
                    class="btn btn-goodcart"
                    :disabled="addressList.length>=20"
                    @click="onAddClick"
                >新增收货地址</van-button>
                <van-button
                    class="btn btn-goodbuy"
                    :class="getBtnCls(invalid)"
                    @click="onSaveClick"
                >确认修改</van-button>
            </div>
        </validation-observer>
    </div>
</template>

<script>
import { addressDel } from "@/api/user";
import { updateAddress } from "@/api/cart";
import { user } from "@/mixin/user";
import { routeCache } from "@/mixin/cache";
import { mixinValid } from "@/mixin/valid";
import zbView from "@/components/data/View";

export default {
    mixins: [user, routeCache, mixinValid],
    name: "CartOrderAddress",
    components: { zbView },
    data() {
        return { id: "", info: { orderCusAddr: {}}, selectId: "" };
    },
    computed: {
        addressList() {
            return this.$store.state.cart.addressList;
        }
    },
    methods: {
        loadList(is = false) {
            this.$store.dispatch("cart/addressList", is);
        },
        userLoginend() {
            const me = this,
                params = me.getCache();
            me.loadList();
            me.info = params.info;
            me.id = params.id;
        },
        // 新增
        onAddClick() {
            this.go("UserAddressEdit", {
                isEdit: false
            });
        },
        // 编辑
        onEditClick(id) {
            this.go("UserAddressEdit", {
                isEdit: true,
                id: id
            });
        },
        onSelectClick(item) {
            this.selectId = item.id;
        },
        onSaveClick() {
            const me = this;
            me.validForm().then(() => {
                updateAddress({
                    customerAddressId: me.selectId,
                    orderId: me.id
                }).then(() => {
                    me.backGo();
                });
            });
        },
        onDelClick(id) {
            this.id = id;
        },
        // position 为关闭时点击的位置
        // instance 为对应的 SwipeCell 实例
        beforeClose({ position, instance }) {
            const me = this,
                id = me.id;

            switch (position) {
                case "outside":
                    instance.close();
                    break;
                case "right":
                    if (id) {
                        me.dialog
                            .confirm({
                                message: "确定删除吗？"
                            })
                            .then(() => {
                                instance.close();
                                addressDel(id).then(res => {
                                    me.loadList(true);
                                });
                            });
                    }
                    break;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.buy-container {
    background: #f1f2f3;
}
.title {
    padding: 30px;
}
.radio {
    margin-right: 20px;
}
.btn-goodbuy,
.btn-goodcart {
    width: 300px;
    margin: 0 10px;
}
.btn-ico-el {
    margin-right: 10px;
}
.btn-container {
    padding: 20px;
}
.swipe-right {
    height: 100%;
}
</style>

